import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link"
import {LineHaulFilterContext} from "../linehaul/context/LineHaulFilterContext";
import {InductAreaContext} from "./context/InductAreaContext";
import {FormattedMessage} from "react-intl";
import {getRefereshInterval} from "../util/Util";

const InductArea = () => {
    const { filter } = useContext(LineHaulFilterContext)
    const {viewModel, dispatch} = useContext(InductAreaContext)

    const getDataForInductArea = () => {
        dispatch({type: 'LOAD_VIEW', data:{filter: filter, dispatcher: dispatch}});
    }

    useEffect(() => {
        getDataForInductArea()
        const interval = setInterval(() => {
            if (!document.hidden) {
                getDataForInductArea();
            }
        }, getRefereshInterval());
        return () => clearInterval(interval);
    },[filter.PackageSize, filter.EAD, filter.Cycle, filter.Cluster, filter.OtherAttributes])

    return (
        <div>
            <Row width="100%" widths={["grid-8"]} spacingInset="large">
                <div>
                    <Heading level ={2} type="h400" alignment="left">
                        <FormattedMessage id="induct.induct_area" defaultMessage="Induct Areas"/>
                    </Heading>
                    <Row width="100%" widths={["grid-6", "grid-3", "grid-3"]} spacingInset="medium none none">
                        <Text type="h100" alignment="right">
                            <FormattedMessage id="induct.active_associate" defaultMessage="Active associates"/>
                        </Text>
                        <Text type="h100" alignment="right">
                            <FormattedMessage id="induct.induct_rate" defaultMessage="Induct rate"/>
                        </Text>
                        <Text type="h100" alignment="right">
                            <FormattedMessage id="induct.total_inducted" defaultMessage="Total Inducted"/>
                        </Text>
                    </Row>
                    {viewModel.inductAreaData.map(inductAreaInsight => (
                        <Row width="100%" widths={["grid-3", "grid-3", "grid-3", "grid-3"]} spacingInset="medium none none">
                            <Text type="h100">{inductAreaInsight.locationName}</Text>
                            <Text alignment="right">
                                {inductAreaInsight.operatorCount > 0 ?
                                    <Link href="#/associate" type="secondary">{inductAreaInsight.operatorCount}</Link>
                                    : inductAreaInsight.operatorCount}
                            </Text>
                            <Text alignment="right">{inductAreaInsight.inductRate}</Text>
                            <Text alignment="right">{inductAreaInsight.volumeInducted}</Text>
                        </Row>
                    ))}
                </div>
            </Row>
        </div>
    )
}

export default InductArea


// WEBPACK FOOTER //
// ./src/components/induct/InductArea.js